import React from 'react';
import CanalDenuncia from './CanalDenuncia';
import Login from './Login';

const Home = () => (
  <div className="c-sii-home">
    <CanalDenuncia />
    <Login />
  </div>
);

export default Home;
